import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import SaveButton from '../builder/SaveButton';

import ShareButton from '../front/buttons/ShareButton';
import VideoEmbed from '../front/VideoEmbed';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText.js';
import EarnedPointsMessage from '../front/loyalty/EarnedPointsMessage.js';

const QuizResultFlex = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;
	const promotion = props?.promotion ?? false;
	const response = props?.response ?? false;
	
	if(promotion === false || response === false) return null;

	const quiz_result = response?.qr ?? false;

	var final_message = quiz_result?.message ?? false;
	if(final_message !== false) final_message = final_message.replace('{{score}}', response.score);

	let final_image = false;
	if(quiz_result.image != null) final_image = (quiz_result.full_image != undefined) ? quiz_result.full_image : quiz_result.image;

	let final_video = false;
	if(quiz_result.video != null) final_video = quiz_result.video;

	const has_final_button = (isNotEmpty(quiz_result, 'cta_url')) ? true : false;

	let has_shared_enabled = (promotion.config.share == undefined || promotion.config.share.status == undefined || promotion.config.share.status != '0') ? true : false;
	if(promotion.login_type != undefined && parseInt(promotion.login_type) == 4) has_shared_enabled = false;	// in Guest Mode we disable the SHARE button

	const has_more_retries = (response.retries > 0) ? true : false;
	/**
	 * Total number of prizes should be gathered in order to solve the use case where max_prizes_stage is bigger than one
	 * We check for most common case that is one.
	 */
	const max_prizes_stage_one_prize_reached =  (props.stage != undefined && props.stage?.max_prizes_stage == '1' && response.prize != false);

	const one_prize_winner = (props.stage != undefined && props.stage?.one_prize_only && response.prize != false) || max_prizes_stage_one_prize_reached;

	return (
		<div class="layout_conts">
			<div class="flex_cols">
				{(final_image || final_video) && (
					<div class="flex_col col_1">
						<div class="final_image_module success_media_flex">
							{(final_image) && (
								<img src={final_image} alt="" style={{maxWidth:'100%'}} />
							)}

							{(final_video) && (
								<VideoEmbed
									video_url={final_video.full_url}
									video_thumb={final_video.image}
								/>
							)}
						</div>
					</div>
				)}

				<div class="flex_col col_2">
					<section class="mod_align_center gui_full_container main_contents_flex">
						<article id="success_contents" class="success_container gui_semi_container">
							<article class="success_status">
								<div class="thankyou_message">
									<LeveledHTMLText
										_class={{other:'gui_main_text_color_on_bg'}}
									>{final_message}</LeveledHTMLText>
									
									<EarnedPointsMessage
										loyalty={response.loyalty}
										promotion={{Promotion:promotion}}
										locale={props.locale}
									/>

									{(has_final_button || has_shared_enabled) && (
										<ul class="main_final_actions mod_align_center">
											{(has_final_button) && (
												<li class="gui_big_button flex_button custom_btn">
													<ActionButton
														_href={quiz_result.cta_url}
														_fullclass=""
														_target={window?.custom_link_target ?? '_blank'}
													>{(isNotEmpty(quiz_result, 'cta_label')) ? quiz_result.cta_label : "Click here"}</ActionButton>
												</li>
											)}

											{(has_shared_enabled && response.share != undefined) && (
												<li>
													<ShareButton
														is_builder={is_builder}
														info={response.share}
														is_mobile={((window?.platform ?? 'desktop') != 'desktop') ? true : false}
														promotion={promotion}
														sharing_type='quiz_result'
														sharing_page='success'
													/>
												</li>
											)}
										</ul>
									)}

									{(response.prize != undefined && response.prize) && (
										<LeveledHTMLText
											_class={{ other:'main_final_actions won_a_prize gui_main_text_color_on_bg' }}
										>
											<p style={{marginBottom:'0.5em'}}>
												<span class="knk-winners" />
											</p>

											<p>{i18n("You've won a prize")}</p>

											<p>
												<ActionLink
													_href={response.url}
												>View prize</ActionLink>
											</p>
										</LeveledHTMLText>
									)}
								</div>
							</article>

							<div class="success_actions gui_main_text_color_on_bg">
								{(has_more_retries && !one_prize_winner) && (
									<div class="entries_btn">
										<SaveButton
											icon='knk-reload'
											type='link'
											onClick={props.play_again}
											_fullclass="original_color_item"
											autotranslate={false}
										>{i18n("Try again")}{(response.retries <= 10) ? ` (${response.retries})` : ''}</SaveButton>
									</div>
								)}

								{(quiz_result.disable_continue == 0) && (
									<div class="entries_btn">
										<ActionLink
											icon='knk-logout'
											_href={response.url}
										>Finalize</ActionLink>
									</div>
								)}
							</div>
						</article>
					</section>
				</div>
			</div>
		</div>
	)
};

export default injectIntl(QuizResultFlex);